import { env } from "@/common/env/client.mjs";
import { httpClient } from "@/services/http";

import { fetchAddressesResponseSchema } from "./fetch-addresses.schema";

export const FETCH_ADDRESSES_ENDPOINT = "/api/v2/addresses/search";

export const fetchAddressesRequest = async (query: string) => {
  // TODO - remove QA exception-handler after migrate Product Pages data to QA;
  const isQA = window.location.hostname.includes("qa");

  const response = await httpClient.get(
    isQA ? `${env.NEXT_PUBLIC_BASE_URL}${FETCH_ADDRESSES_ENDPOINT}` : FETCH_ADDRESSES_ENDPOINT,
    {
      params: { query },
    },
  );
  return fetchAddressesResponseSchema.parse(response);
};
